module.exports = __webpack_public_path__ + "img/spinner.d6e2f088.svg";